var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjectText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5827 3.44102C17.341 3.09102 17.0327 2.78268 16.6827 2.54102C15.891 1.96602 14.8577 1.66602 13.616 1.66602H6.63268C6.46602 1.66602 6.29935 1.67435 6.14102 1.69102C3.40768 1.86602 1.79102 3.64102 1.79102 6.50768V13.491C1.79102 14.7327 2.09102 15.766 2.66602 16.5577C2.90768 16.9077 3.21602 17.216 3.56602 17.4577C4.24935 17.9577 5.11602 18.2493 6.14102 18.316C6.29935 18.3243 6.46602 18.3327 6.63268 18.3327H13.616C16.6494 18.3327 18.4577 16.5244 18.4577 13.491V6.50768C18.4577 5.26602 18.1577 4.23268 17.5827 3.44102ZM15.7493 7.41602C15.7493 7.75768 15.466 8.04102 15.1243 8.04102C14.7827 8.04102 14.4993 7.75768 14.4993 7.41602V6.43268C14.4993 6.16602 14.2827 5.94935 14.016 5.94935H10.7493V14.0494H12.2327C12.5743 14.0494 12.8577 14.3327 12.8577 14.6744C12.8577 15.016 12.5743 15.2994 12.2327 15.2994H8.01602C7.67435 15.2994 7.39102 15.016 7.39102 14.6744C7.39102 14.3327 7.67435 14.0494 8.01602 14.0494H9.49935V5.94935H6.23268C5.96602 5.94935 5.74935 6.16602 5.74935 6.43268V7.41602C5.74935 7.75768 5.46602 8.04102 5.12435 8.04102C4.78268 8.04102 4.49935 7.75768 4.49935 7.41602V6.43268C4.49935 5.47435 5.27435 4.69935 6.23268 4.69935H14.0077C14.966 4.69935 15.741 5.47435 15.741 6.43268V7.41602H15.7493Z",
    fill: "#5D616F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectText);
export default __webpack_public_path__ + "static/media/object_text.3efc97c58b4bdee06c50a8dd5e428807.svg";
export { ForwardRef as ReactComponent };